export const ONBOARDING_BRIDGE_COPY = {
    REQUIRE_LOGIN_TO_CONTINUE: 'Faça login para continuar.',
    INVALID_SESSION: 'Sessão inválida. Faça login novamente.',
    PROFILE_CREATED_SUCCESS: 'Perfil criado com sucesso.',
    PROFILE_CREATED_FAILURE: 'Não foi possível criar o perfil. Tente novamente.',
} as const;
  
export const ONBOARDING_BRIDGE = {
    RECAPTCHA_CONTAINER_ID: 'recaptcha-container-onboarding',
    /** Opção `size` do widget reCAPTCHA (Firebase). */
    RECAPTCHA_SIZE: 'invisible',
    /** Prefixo E.164 fixo para Brasil no MVP. */
    E164_BR_PREFIX: '+55',
    /** Mínimo de dígitos nacionais (DDD + número). */
    MIN_NATIONAL_DIGITS: 10,
} as const;

/** Textos do formulário de onboarding (campos + envio). */
export const ONBOARDING_FORM_COPY = {
    FIELD_NAME_LABEL: 'Nome',
    FIELD_NAME_PLACEHOLDER: 'Seu nome',
    FIELD_COMPANY_LABEL: 'Nome da empresa',
    FIELD_COMPANY_PLACEHOLDER: 'Nome da sua empresa de ar-condicionado',
    FIELD_WHATSAPP_LABEL: 'Celular',
    FIELD_WHATSAPP_PLACEHOLDER: '+55 (00) 00000-0000',
    FIELD_EMAIL_LABEL: 'E-mail',
    FIELD_EMAIL_PLACEHOLDER: 'seu@email.com',
    SUBMIT_LABEL: 'Continuar',
    SUBMIT_LOADING_LABEL: 'Salvando',
    LEGEND_LEGAL_ACCEPTANCE: 'Aceite dos documentos legais',
    WHATSAPP_INVALID: 'Informe um WhatsApp válido.',
    WHATSAPP_DISPLAY_FALLBACK: '+55 (00) 00000-0000',
} as const;

/** Cooldown do reenvio após enviar SMS no onboarding (s). */
export const ONBOARDING_FORM_RESEND_COOLDOWN_SECONDS = 60;

/** Intervalo entre decrementos do cooldown de reenvio (ms). */
export const ONBOARDING_FORM_RESEND_COOLDOWN_TICK_MS = 1000;
/** Textos do aceite legal no onboarding (checkboxes + ações). */

export const ONBOARDING_LEGAL_READ_DOCUMENT = 'Ler';

export const ONBOARDING_LEGAL_TERMS_CHECKBOX =
  'Li e aceito os Termos de Uso. Estou ciente de que o uso do RetornaAr está sujeito a essas condições.';

export const ONBOARDING_LEGAL_PRIVACY_CHECKBOX =
  'Li e aceito a Política de Privacidade. Estou ciente de como meus dados serão tratados.';

export const ONBOARDING_LEGAL_ERROR_MISSING =
  'Marque os dois aceites para continuar: Termos de Uso e Política de Privacidade.';

export const ONBOARDING_PAGE_COPY = {
    TITLE: 'Complete seu perfil',
    SUBTITLE: 'Falta pouco! Preencha seus dados para começar a usar o RetornaAr.',
    LOADING_SUBTITLE: 'Carregando',
    EXIT_LOADING_LABEL: 'Saindo...',
    /** Rodapé: encerra sessão e volta ao login (ex.: número errado). */
    EXIT_FOOTER_LABEL: 'Voltar ao login',
} as const;

  /** Textos do fluxo de verificação de WhatsApp no onboarding (login social). */
export const ONBOARDING_PHONE_VERIFY_BUTTON = 'Enviar SMS de verificação';
export const ONBOARDING_PHONE_VERIFY_SENDING = 'Enviando código';
export const ONBOARDING_PHONE_VERIFY_CODE_SENT_TO = 'Código enviado para';
export const ONBOARDING_PHONE_VERIFY_CHANGE_NUMBER = 'Alterar número';
export const ONBOARDING_PHONE_VERIFY_RESEND = 'Reenviar código';
export const ONBOARDING_PHONE_VERIFY_RESEND_IN = (seconds: number) =>
  `Reenviar em ${seconds}s`;
export const ONBOARDING_PHONE_VERIFY_OTP_LABEL = 'Código de verificação';
/** Linha de status no formulário após número verificado (login SMS ou OTP no onboarding). */
export const ONBOARDING_PHONE_VERIFIED_STATUS = 'Verificado';
export const ONBOARDING_PHONE_VERIFY_SUCCESS = 'Número verificado!';
export const ONBOARDING_PHONE_VERIFY_CODE_SENT_TOAST = 'Código enviado! Verifique o SMS.';
export const ONBOARDING_PHONE_VERIFY_CODE_RESENT_TOAST =
  'Código reenviado! Verifique o SMS.';

export const ONBOARDING_PHONE_VERIFY_ERROR_SUBMIT_WITHOUT_SMS =
  'Verifique o código enviado por SMS antes de continuar.';

  


